import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"saving-pot","clipPath":"url(#clip0_543_8205)"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 4.99927C21 2.79013 19.2091 0.999268 17 0.999268C14.7909 0.999268 13 2.79013 13 4.99927C13 7.20841 14.7909 8.99927 17 8.99927C19.2091 8.99927 21 7.2084 21 4.99927Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.78621 6.19987C6.1612 4.41257 4.26719 4.20508 3 4.49976L4 7.00001L2.5 9.49976L1 9.4999V15.5C2.18712 16.6811 4 17.7431 5.27374 18.2319L6 21.5H10L10.4444 19.5H14.5556L15 21.5H19L19.5337 19.0985C23.0264 16.3831 24.0687 11.4388 21.7942 7.49931C21.6224 7.20169 21.4371 6.91857 21.2396 6.65M9.37769 3.88394C10.578 3.37624 11.8221 3.08514 13.05 3.00709M17 0.999268C19.2091 0.999268 21 2.79013 21 4.99927C21 7.2084 19.2091 8.99927 17 8.99927C14.7909 8.99927 13 7.20841 13 4.99927C13 2.79013 14.7909 0.999268 17 0.999268Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6.5 10.4993H6.50391V10.4954H6.5V10.4993Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SavingPot = Vue.extend<IconProps>({
  name: 'SavingPotIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'saving-pot',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SavingPot;
